/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} St_Hero_SubInputs */

const en_st_hero_sub = /** @type {(inputs: St_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your AI agents already prove every task. Studio turns that proof into what clients pay for: a proposal, a live progress page and a handover package.`)
};

const id_st_hero_sub = /** @type {(inputs: St_Hero_SubInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agen AI kamu sudah membuktikan tiap task. Studio mengubah bukti itu menjadi hal yang dibayar klien: proposal, halaman progres, dan paket serah terima.`)
};

/**
* | output |
* | --- |
* | "Your AI agents already prove every task. Studio turns that proof into what clients pay for: a proposal, a live progress page and a handover package." |
*
* @param {St_Hero_SubInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const st_hero_sub = /** @type {((inputs?: St_Hero_SubInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<St_Hero_SubInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_st_hero_sub(inputs)
	return en_st_hero_sub(inputs)
});